<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Secure Sharing Solution for Marine Industry"
    />
    <v-container>
      <v-row class="row pt-5">
        <v-col class="mt-sm-20" m="12" md="8" lg="8">
          <div>
            <h2>Secure Sharing Solution for Marine Industry</h2>
            <strong>Safeguard Your Credentials with Ease</strong>
            <br /><br />
            In today's marine industry, the secure exchange of credentials is
            paramount. Whether it’s onshore or offshore, sharing sensitive data
            like one-time passwords, login details, or other access credentials
            demands the highest level of security. Our Secure Sharing solution
            is designed specifically for this, ensuring that your data is
            encrypted and shared only with the intended recipient, while
            allowing you to set expiry dates or times for added protection
          </div>

          <div class="pt-3">
            <h3>Key Features:</h3>
          </div>
          <div class="texv pt-4">
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-message-lock </v-icon
            >&nbsp;
            <span class="sicon"><b>Encrypted Communication:</b></span>
            <br />
            <p class="texv">
              All data is encrypted before transmission, ensuring that only the
              recipient can access it.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-calendar-clock</v-icon
            >&nbsp;
            <span class="sicon"><b>Set Expiry Dates/Times:</b></span>
            <br />
            <p class="texv">
              Define how long your credentials remain accessible, adding an
              extra layer of security.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-cloud-lock-outline </v-icon
            >&nbsp; <span class="sicon"><b>Privately Hosted:</b></span>
            <br />
            <p class="texv">
              Our solution can be deployed on your own servers and mapped to
              your company's subdomain for complete control.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large> mdi-shield-check</v-icon
            >&nbsp;
            <span class="sicon"
              ><b>Best Practice for Credential Sharing:</b></span
            >
            <br />
            <p class="texv">
              Avoid risky sharing methods like emails or messenger apps, which
              can expose sensitive information. Our solution is built to meet
              the highest security standards.
            </p>
          </div>

          <div class="pt-3">
            <h3>Why Secure Sharing?</h3>
          </div>
          <div class="texv pt-4">
            <v-icon color="indigo darken-4" x-large> mdi mdi-anchor </v-icon
            >&nbsp;
            <span class="sicon"><b>Designed for the Marine Industry:</b></span>
            <br />
            <p class="texv">
              Whether you're sharing credentials between onshore and offshore
              teams or with third parties, our solution offers seamless and
              secure transfer.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large> mdi mdi-shield-lock</v-icon
            >&nbsp;
            <span class="sicon"><b>Private and Scalable:</b></span>
            <br />
            <p class="texv">
              You can privately host the solution and map it to your subdomain,
              ensuring that only your team controls the data flow.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi-checkbox-marked-circle-outline</v-icon
            >&nbsp; <span class="sicon"><b>Easy to Use:</b></span>
            <br />
            <p class="texv">
              With intuitive setup and configuration, sending secure credentials
              becomes effortless.
            </p>
          </div>

          <div class="pt-5">
            <h3>Try Our Demo!</h3>
            <p>
              Ready to experience secure sharing at its best? Request a demo
              today and see how you can protect your company's sensitive data
              from unauthorized access. Make this solution a standard part of
              your business practices and protect your operations.
            </p>
            <p>
              Don't compromise on security—trust our
              <b>Secure Sharing</b> solution to handle your credentials securely
              and efficiently.
            </p>
            <p>
              Secure Share website
            </p>
            <p>Deployment option: Azure App Service or VM</p>
          </div>
          <div class="text-left my-2 pb-5">
            <v-btn
              href="https://buy.stripe.com/28o2bk8WB85ZgVyaEE"
              x-large
              color="blue darken-2"
              dark
              target="_blank"
            >
              <b>Subscribe Now</b>
            </v-btn>
          </div>
        </v-col>
        <v-col sm="12" md="4" lg="4"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Secure Sharing Solution for Marine Industry";
  }
};
</script>

<style scoped>
.row {
  text-align: justify;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
